//
//
//
//
//

export default {
  name: 'product-card-info-default',
};
